import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import authService from './services/authService';
import { setUser, setToken } from './redux/slices/authSlice';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import SignupPage from './pages/SignupPage';
import ServicesPage from './pages/ServicesPage';
import BookingPage from './pages/BookingPage';
import ProfilePage from './pages/ProfilePage';
import AppointmentsPage from './pages/AppointmentsPage';
import AdminDashboard from './pages/AdminDashboard';
import BarberDashboard from './pages/BarberDashboard';
import ContactPage from './pages/ContactPage';

// Layout
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const { darkMode } = useSelector((state) => state.theme);

  useEffect(() => {
    // Load user on app mount if token exists
    const token = localStorage.getItem('token');
    if (token) {
      authService
        .getCurrentUser()
        .then((response) => {
          dispatch(setUser(response.data));
          dispatch(setToken(token));
        })
        .catch(() => {
          localStorage.removeItem('token');
        });
    }
  }, [dispatch]);

  useEffect(() => {
    // Apply dark mode
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <Router>
      <div className={`min-h-screen flex flex-col ${darkMode ? 'dark' : ''}`}>
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* Auth Routes */}
            {!isAuthenticated ? (
              <>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/admin-login" element={<AdminLoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
              </>
            ) : (
              <>
                <Route path="/booking" element={<BookingPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/appointments" element={<AppointmentsPage />} />
              </>
            )}

            {/* Admin Routes */}
            {isAuthenticated && user?.role === 'admin' && (
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            )}

            {/* Barber Routes */}
            {isAuthenticated && user?.role === 'barber' && (
              <Route path="/barber/dashboard" element={<BarberDashboard />} />
            )}

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </Router>
  );
}

export default App;
